<template>
  <div class="steps">
    <div class="content">
      <div>
        
      </div>
      <progress class="progress" max="50" :value="progrsesValue1"></progress>

    </div>
  </div>
</template>

<script>

export default {
  name:'csteps',
  data() {
    return {
      progrsesValue1: 0
    }
  },
  props: {
    progrsesOne: {
      type: Boolean,
      default: false
    }
  },
  computed: {

  },
  watch: {
    progrsesOne(n, o) {
      console.log(o)
      this.progrsesed(this.progrsesValue1)
    }
  },
  created() {
    // setInterval(()=> {
    //   if (this.progrsesValue1 < 50)
    //   this.progrsesValue1 += 1
    // }, 20)
  },
  methods: {
    progrsesed(value) {
      if (this.progrsesValue1 < 50) {
        this.progrsesValue1 +=1
        setTimeout(()=> {
          this.progrsesed(this.progrsesValue1)
        }, 20)


      }
    }
  }
  
  
}
</script>

<style lang="less" scope>
  .steps {
    width: 100%;
    height: auto;
    .content {
      margin: .16rem;
      height: auto;
      border-radius: 5px;
      background: #E9E9E9;
      display: flex;
      justify-content: center;
      padding: .16rem;
      .progress {
        width: 100%;
        height: .1rem;
      }
      .progress::-webkit-progress-bar {
        background: #ededed;
      }
      .progress::-webkit-progress-value {
        background: yellow;
      }
    }

        

  }
</style>